import { render, staticRenderFns } from "./MainSignDetails.vue?vue&type=template&id=5eb7ab42&"
import script from "./MainSignDetails.vue?vue&type=script&lang=ts&"
export * from "./MainSignDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports